
<ng-container *ngIf="isDataLoading() === false">
<kendo-grid [data]="gridData" 
[pageSize]="state.take"
[skip]="state.skip"
[sort]="state.sort"
[filter]="state.filter"
[sortable]="true"
[pageable]="{
  pageSizes: [5, 10, 20, 50, 100], 
  buttonCount: 5, 
  info: true, 
  type: 'numeric', 
  previousNext: true
}"
[filterable]="true"  
(dataStateChange)="dataStateChange($event)">

<!-- UserId -->
  <!-- <kendo-grid-column field="indicator">
    <ng-template kendoGridHeaderTemplate>
      Binded UserId - to be deleted
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ selectedUserId }}
    </ng-template>
  </kendo-grid-column> -->

<!-- authorized: checkbox -->
  <kendo-grid-column  [width]="40">
    <ng-template kendoGridHeaderTemplate>           
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <input type="checkbox" 
              [value]="dataItem.authorized" 
              [checked]="isPermissionCheckboxChecked(dataItem)" 
              [disabled]="isPermissionCheckboxDisabled(dataItem)"
              (change)="onCheckboxChange(dataItem)">
    </ng-template>
  </kendo-grid-column>

  <!-- indicator -->
  <kendo-grid-column field="indicator" >
    <ng-template kendoGridHeaderTemplate>
      Permission
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.indicator }}
    </ng-template>
  </kendo-grid-column>

   <!-- tutPassed -->
  <kendo-grid-column [width]="120">
    <ng-template kendoGridHeaderTemplate>
      Passed Tutorial
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <input type="checkbox" [value]="dataItem.tutPassed" [checked]="dataItem.tutPassed" [disabled]="true" [hidden]="!dataItem.tutExists">
    </ng-template>
  </kendo-grid-column>

  <!-- tutDate -->
  <kendo-grid-column>
    <ng-template kendoGridHeaderTemplate>
      Tutorial Date
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <span [hidden]="hidetutDate(dataItem.tutExists, dataItem.tutPassed)">{{ formatDate(dataItem.tutDate) }}</span>
    </ng-template>
  </kendo-grid-column>

</kendo-grid>
</ng-container>
